import type { PreOrderSuggestion } from "@stockline/shared/types/ai/pre-order-suggestion"
import type { OfflineResourceConfig } from "../../../types"
import { PRE_ORDER_SUGGESTION_TABLE } from "./db"

export const preOrderSuggestionConfig: OfflineResourceConfig<PreOrderSuggestion> =
  {
    name: "pre-order-suggestions",
    // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
    // scope change (STK-1238).
    groupScoped: true,
    endpoints: {
      full: "/api/v2/pre-order-suggestions",
      delta: "/api/v2/pre-order-suggestions/changes",
      push: "/api/v2/pre-order-suggestions/changes",
    },
    tableName: PRE_ORDER_SUGGESTION_TABLE,
    primaryKey: "id",
    indexes: {
      companyId: "companyId",
      targetId: "targetId",
    },
    applyChange: (local, patch) => ({ ...local, ...patch }),
    // Tombstones stay in Dexie (pulls deliver them as upserts carrying
    // `deletedAt`); readers filter `deletedAt` themselves.
    softDelete: true,
  }
